export default __webpack_public_path__ + "img/i-angle-arrow_left_w.973b26fe.svg";